import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TagModule } from 'primeng/tag';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { DividerModule } from 'primeng/divider';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { API_URL } from '../../utils';

@Component({
  selector: 'lib-about-page',
  standalone: true,
  imports: [CommonModule, DialogModule, ScrollPanelModule, ButtonModule, DividerModule, TagModule, TranslatePipe],
  templateUrl: './about-page.component.html',
  styleUrls: ['./about-page.component.scss']
})
export class AboutPageComponent {
  visible = true;
  version = '3.121.0';
  build = 'build.20251014';

  private router = inject(Router);

  private api = inject(API_URL);
  title: string = '';
  image: string = '';
  disclaimerText: string = '';
  logoAlt: string = '';
  subtitleKey: string = '';

  ngOnInit() {
    if (this.api.includes('coassess')) {
      this.title = 'ABOUT.ABOUT_COASSESS';
      this.image = './assets/media/logos/coassess.png';
      this.disclaimerText = 'ABOUT.Disclaimer_text_coassess';
      this.logoAlt = 'COASSESS logo';
      this.subtitleKey = 'ABOUT.AI_Healthcare_Insurance_Business_Automation';
    }
    else if (this.api.includes('coreact')) {
      this.title = 'ABOUT.ABOUT_COREACT';
      this.image = './assets/media/logos/coreact.png';
      this.disclaimerText = 'ABOUT.Disclaimer_text_coreact';
      this.logoAlt = 'COREACT logo';
       this.subtitleKey = 'ABOUT.AI_Motor_Insurance_Business_Automation';
    }
    else {
      this.title = 'COASSESS/COREACT';
      this.image = './assets/media/logos/coassess.png';
      this.disclaimerText = 'ABOUT.Disclaimer_text_coassess';
      this.logoAlt = 'COASSESS logo';
      this.subtitleKey = 'ABOUT.AI_Healthcare_Insurance_Business_Automation';
    }
  }

  closeModal() {
    this.router.navigate([{ outlets: { modal: null } }]);
  }
}
